import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Typography, makeStyles, Grid } from "@material-ui/core";

import { COLORS } from "../../../../theme/colors";
import { InstalledAsset } from "./InstalledAsset";
import { VerticalDivider } from "../../../../components/base";
import BatteryIcon from "../../../../assets/images/icons/battery.svg";
import SolarIcon from "../../../../assets/images/icons/solar.svg";
import EVIcon from "../../../../assets/images/icons/ev-charge.svg";
import { getData } from "../../../../services";
import { requestDateFormat, onlyUniqueValuesOfKeyInArray } from "../../../../services/utils";

const ENDPOINT = "/praas/v1/power-assets/installed/";
const POWER_ASSETS = [
  {
    name: "EV Chargers",
    iconSrc: EVIcon,
    key: "ev",
  },
  {
    name: "Batteries",
    iconSrc: BatteryIcon,
    key: "battery",
  },
  {
    name: "Solar Sys.",
    iconSrc: SolarIcon,
    key: "solar",
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "16px 24px",
  },
  label: {
    color: theme.palette.success.main,
    letterSpacing: "0.1px",
  },
}));

export const InstalledAssets = () => {
  const classes = useStyles();
  const [data, setData] = useState({});
  const { period, startDate, endDate } = useSelector((state) => state.selectedPeriods);

  useEffect(() => {
    let url = ENDPOINT;

    if (period.name === "RANGE" && endDate) {
      url += `?from_date=${requestDateFormat(startDate)}&to_date=${requestDateFormat(endDate)}`;
    } else if (["YTD", "Acc.", "20Y"].includes(period.name)) {
      url += `?date_filter=${period.filter}`;
    }

    getData(url, (data) => {
      if (!onlyUniqueValuesOfKeyInArray(data.results, "value", 0)) {
        const formattedData = {};

        for (const asset of data.results) {
          formattedData[asset["name"]] = { ...asset };
        }

        setData(formattedData);
      }
    });
  }, [period, startDate, endDate]);

  return (
    <Grid container spacing={1} direction="column" className={classes.root}>
      <Grid item>
        <Typography variant="h3" className={classes.label}>
          Installed Assets
        </Typography>
      </Grid>
      <Grid container item spacing={3}>
        {POWER_ASSETS.map((asset, index) => {
          let divider = (
            <Grid item>
              <VerticalDivider
                containerHeight="100%"
                height="80%"
                color={COLORS.blacks[10]}
                margin="-14px 0px"
              />
            </Grid>
          );

          if (index === 0) {
            divider = null;
          }

          return (
            <React.Fragment key={asset.key}>
              {divider}
              <Grid item>
                <InstalledAsset
                  name={asset.name}
                  iconSrc={asset.iconSrc}
                  count={data[asset.key]?.count}
                  totalPowerCapacity={data[asset.key]?.kwh_value}
                  accumulatedRevenues={data[asset.key]?.accumulated_revenues}
                  annualRevenues={data[asset.key]?.annual_revenues}
                />
              </Grid>
            </React.Fragment>
          );
        })}
      </Grid>
    </Grid>
  );
};
